import { twMerge } from 'tailwind-merge'
import { ISection } from '../../../models/ISection'
import Post from '../../components/Post'
import Link from 'next/link';
import SectionTitle from '../../components/SectionTitle';

export default function SectionNine(data: ISection) {
  if (!data?.posts?.length) return null;
  const post1 = data.posts[0];
  const post2 = data.posts[1];
  const post3 = data.posts[2];
  const post4 = data.posts[3];
  const post5 = data.posts[4];
  return (
      <section key={data.internalName}>
      {data.showTitle && data.title ? <SectionTitle title={data.title} href={`/${data.targetSlug}`} target='_self'/> : null}

       <div className='grid grid-cols-1 tablet:grid-cols-3 desktop:grid-cols-4 desktop:grid-rows-[5fr_5fr_6.75fr] gap-[24px] h-fit'>
          <Post 
          isLarge
          badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
          newsType={post1.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post1.type} 
            title={post1.title}
            image={{
              src: post1.image, 
              fill: true, 
              sizes: '100vw', 
              className:'tablet:aspect-[69/82] rounded-tr-[12px] rounded-tl-[12px] desktop:aspect-[3/4]',
              alt: post1.imageAlt || '', 
              ...(data.eager ? {priority: true, loading: 'eager'} : {})
            }} 
            category={post1.category} 
            uniqueCode={post1.uniqueCode}
            hide={{category: true}}
            classNames={{
              wrapper: twMerge(
                'flex-1 rounded-[12px] tablet:h-full tablet:row-span-4 tablet:col-span-2 desktop:col-start-1 desktop:col-end-2 desktop:row-start-1 desktop:row-end-3',
              ),
              image: twMerge('mb-0 desktop:aspect-[3/4]'),
              contentContainer: 'p-[16px] flex-1', 
              title: twMerge('h3 desktop:h5 line-clamp-2'), 
            }}
            thumbnail={post1.thumbnail}
          />

            <Post 
            badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
            newsType={post2.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post2.type} 
            title={post2.title}
            image={{
              src: post2.image, 
              fill: true, 
              sizes: '100vw', 
              className: 'tablet:aspect-[3/4] rounded-[12px] rounded-tl-[12px] rounded-tr-[12px] tablet:rounded-b-none desktop:aspect-[4/3]',
              alt: post2.imageAlt || '', 
            }} 
            category={post2.category} 
            uniqueCode={post2.uniqueCode}
            hide={{category: true}}
            classNames={{
              wrapper: twMerge(
                'flex-1 flex-row tablet:flex-col rounded-[12px] tablet:h-full desktop:col-start-1 desktop:col-end-2 desktop:row-start-3 desktop:row-end-4',
              ),
              image: twMerge('mb-0 flex-1'), 
              contentContainer: 'p-[16px] flex-1', 
              title: twMerge('h5 line-clamp-4 tablet:line-clamp-2'), 
            }}

            thumbnail={post2.thumbnail}
          />

            <Post 
            badge={{mobile: 'image', tablet: 'inline', desktop: 'image'}}
            newsType={post3.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post3.type} 
            title={post3.title}
            image={{
              src: post3.image, 
              fill: true, 
              sizes: '100vw', 
              className: 'tablet:hidden desktop:block rounded-[12px] rounded-tl-[12px] rounded-tr-[12px] tablet:rounded-b-none  desktop:aspect-[53/63]',
              alt: post3.imageAlt || '', 
            }} 
            category={post3.category} 
            uniqueCode={post3.uniqueCode}
            hide={{category: true}}
            classNames={{
              wrapper: twMerge(
                'flex-1 flex-row tablet:flex-col rounded-[12px] tablet:h-full desktop:col-start-2 desktop:col-end-4 desktop:row-start-1 desktop:row-end-4 desktop:h-full',
              ),
              image: twMerge('tablet:hidden desktop:block  mb-0 desktop:aspect-[53/63] flex-1'), 
              contentContainer: 'p-[16px] flex-1', 
              title: twMerge( 'h5 desktop:h3 line-clamp-4 tablet:line-clamp-2'), 
            }}
            thumbnail={post3.thumbnail}
          />

            <Post 
              badge={{mobile: 'image', tablet: 'inline', desktop: 'image'}}
            newsType={post4.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post4.type} 
            title={post4.title}
            image={{
              src: post4.image, 
              fill: true, 
              sizes: '100vw', 
              className: 'tablet:hidden desktop:block  desktop:aspect-[3/4] rounded-[12px] rounded-tl-[12px] rounded-tr-[12px] tablet:rounded-b-none ',
              alt: post4.imageAlt || '', 
            }} 
            category={post4.category} 
            uniqueCode={post4.uniqueCode}
            hide={{category: true}}
            classNames={{
              wrapper: twMerge(
                'flex-1 flex-row tablet:flex-col rounded-[12px] tablet:h-full desktop:col-start-4 desktop:col-end-5 desktop:row-start-1 desktop:row-end-3',
              ),
              image: twMerge('tablet:hidden desktop:block  mb-0 flex-1 desktop:aspect-[3/4]'), 
              contentContainer: 'p-[16px] flex-1', 
              title: twMerge('h5 line-clamp-4 tablet:line-clamp-2'), 
            }}
            thumbnail={post4.thumbnail}
          />

            <Post 
              badge={{mobile: 'image', tablet: 'inline', desktop: 'image'}}
            newsType={post5.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post5.type} 
            title={post5.title}
            image={{
              src: post5.image, 
              fill: true, 
              sizes: '100vw', 
              className: 'tablet:hidden desktop:block desktop:aspect-[4/3] rounded-[12px] rounded-tl-[12px] rounded-tr-[12px] tablet:rounded-b-none',
              alt: post5.imageAlt || '', 
            }} 
            category={post5.category} 
            uniqueCode={post5.uniqueCode}
            hide={{category: true}}
            classNames={{
              wrapper: twMerge(
                'flex-1 flex-row tablet:flex-col rounded-[12px] tablet:h-full desktop:col-start-4 desktop:col-end-5 desktop:row-start-3 desktop:row-end-4',
              ),
              image: twMerge('tablet:hidden desktop:block mb-0 flex-1'), 
              contentContainer: 'p-[16px] flex-1', 
              title: twMerge('h5 line-clamp-4 tablet:line-clamp-2'), 
            }}
            thumbnail={post5.thumbnail}
          />
       </div>

           <Link href={`/${data.targetSlug}`} className={twMerge('rounded-[6px] grid place-items-center w-fit px-[12px] h-[36px] cursor-pointer transition-all duration-300 hover:scale-[103%] self-end ml-[24px] desktop:ml-0 bg-gray-100 dark:bg-quaternary')}>
      <span className='text-dark dark:text-white h6'>المزيد</span>
    </Link>
      </section>
  )
}